import { useMemo } from "react";
import { countBy } from "lodash";
import { getCandidateStatusKey } from "../../../../../utilities/candidate";

export const useTransitionCounts = (transitions) => {
  return useMemo(() => {
    const activeTransitions = transitions.filter((t) => t.isActive);

    const incomingCounts = countBy(activeTransitions, (t) =>
      getCandidateStatusKey(t.toStatusId, t.toSubStatusId),
    );

    const outgoingCounts = countBy(activeTransitions, (t) =>
      getCandidateStatusKey(t.fromStatusId, t.fromSubStatusId),
    );

    return { incomingCounts, outgoingCounts };
  }, [transitions]);
};
